import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { setupInterceptors } from './api/http'

import BaseSpinner from "@/ui/BaseSpinner.vue";
import BaseCard from "@/ui/BaseCard.vue";

loadFonts()

setupInterceptors(store, router); // API 인터셉터 설정 (401 시 토큰 재발급 / 실패하면 로그인으로)

const app = createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    .component('BaseSpinner', BaseSpinner)
    .component('BaseCard', BaseCard)


app.config.errorHandler = (err, vm, info) => {
    console.error('JBJB Global error:', err, info);
    // Handle the error globally
};

app.mount('#app')